<template>
  <div>
    <div class="box-save-minus">
      <div class="typeface-size" :style="{ fontSize: fontSize + 'px' }">
        第 {{ choiceQuestionsNum }} 题 (不定项选择题)
      </div>
      <div class="font-size-save-minus">
        <el-button size="small" @click="increaseFontSize">+</el-button>
        <span>{{ text }}</span>
        <el-button size="small" @click="decreaseFontSize">-</el-button>
      </div>
    </div>
    <!-- <div class="name">第 {{ choiceQuestionsNum }} 题 (不定项选择题)</div> -->
<!--    <div class="name" :style="{ fontSize: fontSize + 'px' }">
      {{ choiceQuestionsContent }}
    </div>-->
    <div class="name" :style="{ fontSize: fontSize + 'px' }" v-html="choiceQuestionsContent">
    </div>
    <div v-for="(item, index) in ChoiceQuestionsList" :key="index">
      <topic-check
        ref="paper"
        :key="`check-content-${index}`"
        :CheckNum="index + 1"
        :titleShow="false"
        :CheckContent="item.indefiniteQuestContent"
        :CheckList="JSON.parse(item.indefiniteConf)"
        :data-id="item.subjectId"
        :data-son-id="item.id"
        :currentAnswer="item.currentAnswer"
        @change="handleChange"
      ></topic-check>
    </div>
  </div>
</template>
<script>
import TopicCheck from "@/components/topicCheck.vue";
export default {
  components: {
    TopicCheck,
  },
  props: {
    choiceQuestionsNum: {
      type: Number,
      require: true,
      default: 0,
    },
    choiceQuestionsContent: {
      type: String,
      require: true,
    },
    ChoiceQuestionsList: {
      type: Array,
      require: true,
      default: [],
    },
    // choiceQuestionsDetails: {
    //   type: Array,
    //   require: true,
    //   default: [],
    // },
    dataId: {
      type: String | Number,
      require: true,
    },
    currentAnswer: {
      type: Array,
    },
  },
  watch: {
    // currentAnswer: {
    //   handler(val) {
    //     if (!val) return;
    //     this.choiceQuestionsList = val;
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
  data() {
    return {
      // choiceQuestionsList: [],
      // choiceQuestionsList: this.ChoiceQuestionsList.map(() => []),
      text: "字号",
      fontSize: 16, // 初始字体大小
    };
  },
  methods: {
    onSubmit() {
      return {
        No: this.choiceQuestionsNum,
        // answer: this.choiceQuestionsList,
        dataId: this.dataId,
      };
    },
    handler(e, index) {
      this.$emit("change", this.dataId, {
        No: this.choiceQuestionsNum,
        answer: e,
        dataId: this.dataId,
      });
    },
    handleChange(data, sunjectId) {
      this.$emit("change", sunjectId, data);
    },
    increaseFontSize() {
      if (this.fontSize == 28) {
        this.$message({
          message: "已达到最大值",
          type: "warning",
        });
      } else {
        this.fontSize += 2;
      }
    },
    decreaseFontSize() {
      if (this.fontSize == 10) {
        this.$message({
          message: "已达到最小值",
          type: "warning",
        });
      } else {
        this.fontSize -= 2;
      }
    },
  },
};
</script>
<style scoped>
.el-checkbox-group {
  display: flex;
  flex-direction: column;
}
.el-checkbox {
  margin-top: 40px;
}
.el-checkbox >>> .el-checkbox__label {
  padding-left: 24px;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 24px;
}
.el-checkbox >>> .el-checkbox__inner {
  width: 40px;
  height: 40px;
  box-sizing: border-box;
  border: 2px solid rgb(64, 112, 179);
  /* border-radius: 50%; */
}
.el-checkbox >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: rgb(64, 112, 179);
}
.el-checkbox >>> .el-checkbox__inner::after {
  height: 18px;
  position: absolute;
  top: -5px;
  left: 0px;
  width: 12px;
}
.name {
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 30px;
}
.box-save-minus {
  height: 50px;
}
.typeface-size {
  float: left;
  color: rgb(0, 0, 0);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
}
.font-size-save-minus {
  font-family: 思源黑体;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/topicChoiceQuestions.vue